import { render, staticRenderFns } from "./DetailBlog.vue?vue&type=template&id=00ccc4f0&"
import script from "./DetailBlog.vue?vue&type=script&lang=js&"
export * from "./DetailBlog.vue?vue&type=script&lang=js&"
import style0 from "./DetailBlog.vue?vue&type=style&index=0&id=00ccc4f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports